import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-career-challenge-admin-shell',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, MatButtonModule, MatIconModule, RouterOutlet],
  templateUrl: './career-challenge-admin-shell.component.html',
  styleUrl: './career-challenge-admin-shell.component.scss'
})
export class CareerChallengeAdminShellComponent {
  private readonly router = inject(Router);

  backToAdmin(): void {
    void this.router.navigate(['/admin']);
  }

  goHome(): void {
    void this.router.navigate(['/admin/career-challenges']);
  }
}
